import { Box, Heading, HStack, Text, VStack } from '@gluestack-ui/themed';
import { useContext, type FC } from 'react';
import { StyleSheet } from 'react-native';
import { TranslationContext } from '../../contexts/translations/Translation';
import { COLORS } from '../../theme/colors';

export interface IAnalysisHistoryListEmptyItemProps {
  testID?: string;
}

const Step: FC<{ n: number; text?: string }> = ({ n, text }) => (
  <HStack style={styles.step} alignItems="center">
    <Box style={styles.badge}>
      <Text style={{ color: 'white', fontWeight: 'bold' }}>{n}</Text>
    </Box>
    <Text style={{ flex: 1 }}>{text}</Text>
  </HStack>
);

export const AnalysisHistoryListEmptyItem: FC<IAnalysisHistoryListEmptyItemProps> = (props: IAnalysisHistoryListEmptyItemProps) => {
  const { testID } = props;
  const { i18n } = useContext(TranslationContext);
  const b = 'page.analysis.history-list';

  return (
    <VStack style={styles.layout} gap={10}>
      <Heading size="md" testID={`${testID ?? ''}${AnalysisHistoryListEmptyItem.name}_empty`}>
        {i18n?.t(`${b}.empty-title`)}
      </Heading>
      <Text color={COLORS.NEUTRAL[90]}>{i18n?.t(`${b}.empty-intro`)}</Text>
      <VStack gap={8} style={{ marginTop: 4 }}>
        <Step n={1} text={i18n?.t(`${b}.empty-step-1`)} />
        <Step n={2} text={i18n?.t(`${b}.empty-step-2`)} />
        <Step n={3} text={i18n?.t(`${b}.empty-step-3`)} />
      </VStack>
      <Text fontSize={13} color={COLORS.ACCENT[100]} style={{ marginTop: 4 }}>
        {i18n?.t(`${b}.empty-hint`)}
      </Text>
    </VStack>
  );
};

const styles = StyleSheet.create({
  layout: {
    backgroundColor: '#F4F6F8',
    borderRadius: 10,
    margin: 10,
    padding: 18,
  },
  step: {
    gap: 10,
  },
  badge: {
    width: 26,
    height: 26,
    borderRadius: 13,
    backgroundColor: COLORS.ACCENT[100],
    alignItems: 'center',
    justifyContent: 'center',
  },
});
